import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { isEmbedded } from '#/features/system/utils';
import { logException } from '#/features/logging/logging';

interface UserMetadata {
  id: string | null;
  email: string | null;
  name: string | null;
}

export function useParentUserMetadata() {
  const [user, setUser] = useState<UserMetadata | null>(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!isEmbedded()) return;

    const id = searchParams.get('embedded_user_id');
    const email = searchParams.get('embedded_user_email');
    const name = searchParams.get('embedded_user_name');
    const noValuesAvailable = [id, email, name].every((value) => value == null);

    if (noValuesAvailable) return;

    setUser({ id, email, name });
  }, [searchParams]);

  return user;
}

export type Token = string | null;
export function useParentUserToken() {
  const [token, setToken] = useState<Token>(null);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const embeddedUserToken = searchParams.get('embedded_user_token');
    if (isEmbedded() && embeddedUserToken == null && token == null) {
      logException(
        new Error(
          'Paradex runs in an iframe but no parent user token detected.',
        ),
      );
    }

    if (!isEmbedded()) return;
    if (embeddedUserToken == null) return;

    setToken(embeddedUserToken);
  }, [searchParams, setToken, token]);

  return token;
}
